import { db, getUser } from '@/firebaseApp';
import { Teacher as ITeacher } from '@/models/Teachers';
import { UserRole } from '@/models/Enums';
import { Teacher as TeacherModel } from '@/models/Teachers';

class Teacher {
  async observeAllTeachers(f: (teachers: ITeacher[]) => void) {
    db.collection('teachers').onSnapshot(
      snapshot => {
        const teachers: ITeacher[] = [];

        snapshot.forEach(doc => {
          const teacher = doc.data() as ITeacher;
          teacher.id = doc.id;
          teachers.push(teacher);
        });

        teachers.sort((t1, t2) => {
          if (t1.name < t2.name) {
            return -1;
          } else if (t1.name > t2.name) {
            return 1;
          } else {
            return 0;
          }
        });

        f(teachers);
      },
      err => {
        console.error(`Encountered error: ${err}`);
      }
    );
  }

  async getTeacherById(id: string) {
    const doc = await db
      .collection('teachers')
      .doc(id)
      .get();

    if (!doc.exists) {
      return null;
    }

    const teacher = doc.data() as ITeacher;
    teacher.id = id;

    return teacher;
  }

  async createTeacher(newTeacher: Partial<TeacherModel>) {
    const user = getUser();
    if (!user || !newTeacher) {
      return null;
    }

    newTeacher.email = newTeacher.email && newTeacher.email.trim();
    newTeacher.name = newTeacher.name && newTeacher.name.trim();
    newTeacher.school = newTeacher.school && newTeacher.school.trim();

    newTeacher.modules = [];
    return (await db.collection('teachers').add(newTeacher)).id;
  }

  async updateTeachermModuleOrder(teacherId: string, moduleIds: string[]) {
    return db
      .collection('teachers')
      .doc(teacherId)
      .set({ modules: moduleIds }, { merge: true });
  }

  async updateClassroomOrder(teacherId: string, classroomIds: string[]) {
    return db
      .collection('teachers')
      .doc(teacherId)
      .set({ classrooms: classroomIds }, { merge: true });
  }

  getTeacherObserverByEmail(teacherEmail: string) {
    return db.collection('teachers').where('email', '==', teacherEmail);
  }

  async getLoggedInTeacher() {
    const user = getUser();
    if (!user) {
      return null;
    }

    const snapshot = await db
      .collection(UserRole.Teacher)
      .where('email', '==', user.email)
      .get();

    return !snapshot.empty
      ? ({ ...snapshot.docs[0].data(), id: snapshot.docs[0].id } as ITeacher)
      : null;
  }
}

export default new Teacher();
